import store from "../../store";


/**
 * 获取数据
 * @param key 目标前缀key
 * @return {Promise<*>}
 */
export const getter = (key) => {
  return new Promise(async (resolve) => {
    const stateKey = key + "State";
    const actionKey = key + "Action";
    let data = store.state[stateKey];
    if (Array.isArray(data) && data.length === 0) {
      data = await store.dispatch(actionKey);
    }
    resolve(data);
  })
}
